import { PropsWithChildren } from 'react';
import MobileViewToggle from '../MobileViewToggle/MobileViewToggle';
import styles from './MobileResultsList.module.scss';

type Props = {};

const MobileResultsList = ({ children }: PropsWithChildren<Props>) => {
  return (
    <div className={styles.mobileTrailList}>
      {children}
      <MobileViewToggle className={styles.mobileViewToggle} />
    </div>
  );
};

export default MobileResultsList;
